import React from "react";

const Contact = () => {
  const contacts = [
    {
      title: "Kathmandu, Nepal",
      address: "FredHour Pvt. Ltd.\nKathmandu, Nepal",
      email: "info@fredhour.com.np",
      phone: "+977-9860089195"
    },
    {
      title: "Australia",
      address: "FredHour Australia\nPerth, 108 Lakefield Drive Brabham",
      email: "developer.ausservice@gmail.com",
      phone: "+61-452064476"
    },
    {
      title: "Canada",
      address: "FredHour Canada\nOttawa, 861 Zator Ave, ON",
      email: "janam.maharjan@fredhour.com.np",
      phone: "+1-4168359196"
    }
  ];

  return (
    <div className="container my-5 pt-5">

      {/* Heading */}

      <div className="text-center mb-5">
        <h2
          className="fw-bold mb-3"
          style={{ fontSize: "35px", color: "#333333" }}
        >
          Get In Touch
        </h2>

        <p
          style={{
            fontSize: "14px",
            color: "#555555",
            maxWidth: "650px",
            margin: "0 auto"
          }}
        >
          Have a question or want to work with us? Reach out to any of our
          offices below and our team will be happy to assist you.
        </p>
      </div>

      {/* Contact Cards */}

      <div className="row justify-content-center g-4">

        {contacts.map((contact, index) => (
          <div className="col-md-4" key={index}>
            <div
              className="p-4 h-100"
              style={{
                backgroundColor: "white",
                borderRadius: "15px",
                textAlign: "center",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                border: "1px solid #cfd8e3"
              }}
            >

              <h5 className="fw-bold mb-3" style={{ color: "#333333" }}>
                {contact.title}
              </h5>

              <p
                style={{
                  whiteSpace: "pre-line",
                  fontSize: "14px",
                  color: "#555555"
                }}
              >
                {contact.address}
              </p>

              <p style={{ fontSize: "14px", marginBottom: "5px" }}>
                📧 {contact.email}
              </p>

              <p style={{ fontSize: "14px" }}>
                📞 {contact.phone}
              </p>

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Contact;